import { MEAS_BY_SLUG } from '../../config/measConfig'
import { MeasGrafTable } from './MeasGrafTable'
import { unionNodeGhIds } from '../../utils/computeGroupTree'

// Produkt "Měřené veličiny" — rozhoduje list vs. kategorie podle vybraného uzlu stromu skupin, viz
// doc/plans/station-group-meas.md sekce 4/4a. Nodes k vykreslení: list -> [selectedNode];
// kategorie -> selectedNode.children; kořen -> filteredTree (root uzly).
export function StationGroupMeasView({ measQ, selectedNode, selectedPath, stationsByGhId, filteredTree }) {
  const measDef = MEAS_BY_SLUG.get(measQ)
  if (!measDef) return null // neznámé q, neměl by nastat

  const isSingleLeaf = !!selectedNode && selectedNode.children.length === 0
  const nodes = selectedNode
    ? (isSingleLeaf ? [selectedNode] : selectedNode.children)
    : filteredTree // na kořeni (Všechny stanice) = root uzly stromu

  const heading = selectedPath.length > 0 ? selectedPath[selectedPath.length - 1].bucketLabel : 'Všechny stanice'

  // Klíč vynucující remount MeasGrafTable (a tedy reset jejího lokálního state — hlavně gate
  // potvrzení "zobrazit i přesto", sekce 4a-i) při jakékoli změně skutečné množiny stanic pod
  // vybraným uzlem — tj. při změně skupiny, filtrů, i při kliku na jiný uzel/veličinu. Bez
  // remountu by React state (useState) v MeasGrafTable přežil i změnu nodes props, protože
  // komponenta zůstává na stejném místě stromu.
  const allGhIds = new Set()
  for (const node of nodes) for (const gh of unionNodeGhIds(node)) allGhIds.add(gh)
  const gateKey = `${[...allGhIds].sort().join(',')}::${measDef.q}`

  return (
    <div className="flex flex-col h-full overflow-hidden">
      {!isSingleLeaf && (
        <h2 className="px-4 pt-3 pb-1 text-sm font-semibold text-gray-700 bg-white border-b border-gray-100">
          {heading} — {measDef.label}
        </h2>
      )}
      <div className="flex-1 min-h-0">
        <MeasGrafTable
          key={gateKey}
          nodes={nodes}
          measDef={measDef}
          stationsByGhId={stationsByGhId}
          isSingleLeaf={isSingleLeaf}
        />
      </div>
    </div>
  )
}
